import ButtonV2, { getButtonClasses } from "components/elements/buttonV2"
import Image from "components/elements/image"
import TextLockupV2 from "components/elements/textLockupV2"
import PropTypes from "prop-types"
import React from "react"
import Quote from "./quote"
import "./section-book-highlight-v2.scss"

const SectionBookHighlightV2 = ({
  audibleLink,
  bookImage,
  cite,
  orderLink,
  quote,
  quotePhoto,
  text,
  title,
}) => {
  return (
    <section className="section-book-highlight-v2">
      <div className="container-v2">
        <div className="section-book-highlight-v2--content-wrapper">
          <div className="section-book-highlight-v2--content">
            {title && (
              <h2 className="section-book-highlight-v2--title">
                <TextLockupV2>{title}</TextLockupV2>
              </h2>
            )}
            {text?.childrenMarkdownRemark?.[0]?.html && (
              <div
                className="section-book-highlight-v2--text"
                dangerouslySetInnerHTML={{
                  __html: text?.childrenMarkdownRemark?.[0]?.html,
                }}
              />
            )}
            <div className="section-book-highlight-v2--quote-links">
              {orderLink && (
                <p className="section-book-highlight-v2--quote-link section-book-highlight-v2--quote-link-order">
                  <ButtonV2
                    accessibilityLabel="Order Online"
                    className={getButtonClasses("Solid Blue", "small")}
                    href={orderLink}
                    key={orderLink}
                    newWindow={true}
                    showArrow={true}
                    text="Order Online"
                  />
                </p>
              )}
              {audibleLink && (
                <p className="section-book-highlight-v2--quote-link section-book-highlight-v2--quote-link-audible">
                  <ButtonV2
                    accessibilityLabel="Listen on Audible"
                    className={getButtonClasses("Outline Blue", "small")}
                    href={audibleLink}
                    key={orderLink}
                    newWindow={true}
                    showArrow={false}
                    text="Listen on Audible"
                  />
                </p>
              )}
            </div>

            {quote && cite && quotePhoto && (
              <div className="section-book-highlight-v2--quote-lg">
                <Quote cite={cite} headshot={quotePhoto} quote={quote} />
              </div>
            )}
          </div>
          {bookImage?.fluid && (
            <div className="section-book-highlight-v2--image">
              <Image image={bookImage?.fluid} />
            </div>
          )}
          {quote && cite && quotePhoto && (
            <div className="section-book-highlight-v2--quote-sm">
              <Quote cite={cite} headshot={quotePhoto} quote={quote} />
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

SectionBookHighlightV2.propTypes = {
  audibleLink: PropTypes.string.isRequired,
  bookImage: PropTypes.object.isRequired,
  cite: PropTypes.string.isRequired,
  orderLink: PropTypes.string.isRequired,
  quote: PropTypes.object.isRequired,
  quotePhoto: PropTypes.object.isRequired,
  text: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default SectionBookHighlightV2
